// import GLightbox from "glightbox";
import "bootstrap/dist/js/bootstrap.bundle";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import observeStickyElement from "./stickyStuck";
import Splide from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";
import AOS from "aos";
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
document.addEventListener("DOMContentLoaded", function () {
	AOS.init({
		easing: "ease-in-out",
		offset: 50,
	});

	if (document.querySelector(".jsCarousel")) {
		var elms = document.getElementsByClassName("jsCarousel");

		for (var i = 0; i < elms.length; i++) {
			new Splide(elms[i], {
				type: "loop",
				drag: "free",
				focus: "center",
				perPage: 5,
				arrows: false,
				pagination: false,
				autoWidth: true,
				autoScroll: {
					speed: 1,
				},
			}).mount({ AutoScroll });
		}
	}

	if (document.querySelector(".jsSingleImageCarousel")) {
		new Splide(".jsSingleImageCarousel", {
			type: "loop",
			pagination: true,
			perPage: 1,
			autoplay: true,
			interval: 3000,
			pauseOnHover: true,
			pauseOnFocus: true,
			gap: "1rem",
		}).mount();
	}

	if (document.querySelector(".jsTestimonials")) {
		document.querySelectorAll(".jsTestimonials").forEach((test) => {
			new Splide(test, {
				type: "loop",
				pagination: false,
				perPage: 2,
				autoplay: true,
				interval: 3000,
				pauseOnHover: true,
				pauseOnFocus: true,
				gap: "1rem",
				breakpoints: {
					320: {
						perPage: 1,
					},
					768: {
						perPage: 2,
					},
				},
			}).mount();
		});
	}
	// images carousel with thumbnails
	if (document.querySelector(".jsGalleryParent")) {
		document.querySelectorAll(".jsGalleryParent").forEach((galleryParent) => {
			var gallery = galleryParent.querySelector(".jsGalleryMain");
			var thumbnails = galleryParent.querySelector(".jsGalleryThumbnails");
			var main = new Splide(gallery, {
				type: "fade",
				rewind: true,
				pagination: false,
				arrows: false,
			});

			var thumbnails = new Splide(thumbnails, {
				// fixedWidth: 100,
				// fixedHeight: 60,
				perPage: 5,
				gap: "1rem",
				rewind: true,
				pagination: false,
				isNavigation: true,
				breakpoints: {
					600: {
						fixedWidth: 60,
						fixedHeight: 44,
					},
				},
			});

			main.sync(thumbnails);
			main.mount();
			thumbnails.mount();
		});
	}

	if (document.querySelector(".jsCardsSlider")) {
		new Splide(".jsCardsSlider", {
			type: "slide",
			// focus: "center",
			pagination: false,
			padding: "7rem",
			perPage: 4,
			gap: "2rem",
			trimSpace: false,
			arrows: false,
			breakpoints: {
				768: {
					perPage: 1,
					padding: "3rem",
				},
				1280: {
					perPage: 2,
				},
				1700: {
					perPage: 3,
				},
			},
		}).mount();
	}

	// observeStickyElement();

	ScrollTrigger.create({
		start: "top -80",
		end: 99999,
		toggleClass: {
			className: "is-stuck",
			targets: ".header",
		},
	});
	// Hover dropdown functionality
	const dropdownHovers = document.querySelectorAll(".dropdown-hover");

	dropdownHovers.forEach((dropdown) => {
		const dropdownToggle = dropdown.querySelector(".dropdown-toggle");
		const dropdownMenu = dropdown.querySelector(".dropdown-menu");

		// Handle hover events for desktop
		dropdown.addEventListener("mouseenter", function () {
			if (window.innerWidth > 991) {
				// Only on desktop
				dropdownMenu.classList.add("show");
				dropdownToggle.setAttribute("aria-expanded", "true");
			}
		});

		dropdown.addEventListener("mouseleave", function () {
			if (window.innerWidth > 991) {
				// Only on desktop
				dropdownMenu.classList.remove("show");
				dropdownToggle.setAttribute("aria-expanded", "false");
			}
		});

		// Handle click on mobile devices
		dropdownToggle.addEventListener("click", function (e) {
			if (window.innerWidth <= 991) {
				// Only on mobile
				e.preventDefault();
				const isOpen = dropdownMenu.classList.contains("show");

				// Close all other dropdowns
				dropdownHovers.forEach((otherDropdown) => {
					if (otherDropdown !== dropdown) {
						otherDropdown
							.querySelector(".dropdown-menu")
							.classList.remove("show");
						otherDropdown
							.querySelector(".dropdown-toggle")
							.setAttribute("aria-expanded", "false");
					}
				});

				// Toggle current dropdown
				if (isOpen) {
					dropdownMenu.classList.remove("show");
					dropdownToggle.setAttribute("aria-expanded", "false");
				} else {
					dropdownMenu.classList.add("show");
					dropdownToggle.setAttribute("aria-expanded", "true");
				}
			}
		});
	});

	// Close dropdowns when clicking outside on mobile
	document.addEventListener("click", function (e) {
		if (window.innerWidth <= 991 && !e.target.closest(".dropdown-hover")) {
			dropdownHovers.forEach((dropdown) => {
				dropdown.querySelector(".dropdown-menu").classList.remove("show");
				dropdown
					.querySelector(".dropdown-toggle")
					.setAttribute("aria-expanded", "false");
			});
		}
	});
});
